import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import Modal from '../../components/common/Modal';
import Typography from '../../components/common/Typography';
import { EvidenceTypeSelectedButton } from './AddButton';

const EvidenceTypeModal = ({ handleCategory, onClose }) => {
  const { t } = useTranslation('evidenceDocuments');
  const { categoryList } = useSelector(state => state.evidenceDocuments);
  // const [categoryList, setCategoryList] = useState([
  //   { htmItemSeqName: '주민등록등본', htmItemSeq: '1' },
  //   { htmItemSeqName: '가족관계증명서', htmItemSeq: '2' },
  //   { htmItemSeqName: '장애인증명서', htmItemSeq: '3' },
  //   { htmItemSeqName: '장애인증명서', htmItemSeq: '3' },
  //   { htmItemSeqName: '장애인증명서', htmItemSeq: '3' },
  //   { htmItemSeqName: '장애인증명서', htmItemSeq: '3' },
  //   { htmItemSeqName: '장애인증명서', htmItemSeq: '3' },
  //   { htmItemSeqName: '장애인증명서', htmItemSeq: '3' },
  // ]);
  return (
    <Modal width="calc(100% - 32px)" height="400px" onClickBackground={onClose}>
      <div className="modalTitleWrapper">
        <Typography variant="body1Bold" color="GrayScale-900">
          {t('typeSelectTitle')}
        </Typography>
      </div>
      <div className="modalContentWrapper">
        {categoryList.map((category, index) => (
          <EvidenceTypeSelectedButton
            key={index}
            title={category.htmItemSeqName}
            onClick={() => handleCategory(category)}
          />
        ))}
      </div>
    </Modal>
  );
};

export default EvidenceTypeModal;
